import { createRouter, createWebHistory } from 'vue-router'; 

import HomePage from '../pages/HomePage.vue';

// Define your routes
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  }
];

// Create and export the router instance (no need for Vue.use())
const router = createRouter({
  history: createWebHistory(),  // Use history mode for the router
  routes,  // Pass the routes array
});

export default router;
